var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M20 6h-3v-1c0-1.7-1.3-3-3-3h-4c-1.7 0-3 1.3-3 3v1h-3c-1.7 0-3 1.3-3 3v10c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-10c0-1.7-1.3-3-3-3zM9 5c0-0.6 0.4-1 1-1h4c0.6 0 1 0.4 1 1v1h-6v-1zM15 8v12h-6v-12h6zM3 19v-10c0-0.6 0.4-1 1-1h3v12h-3c-0.6 0-1-0.4-1-1zM21 19c0 0.6-0.4 1-1 1h-3v-12h3c0.6 0 1 0.4 1 1v10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsIcon);
export default __webpack_public_path__ + "static/media/bookings-icon.810874ed1a7c19cdf5fab5669eb82f13.svg";
export { ForwardRef as ReactComponent };